// extracted by mini-css-extract-plugin
export default {"button":"SortableHeaderCell_button__daQu7","arrow":"SortableHeaderCell_arrow__ZX6TM","arrowDown":"SortableHeaderCell_arrowDown__fARVH"};